import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import _ from 'lodash';
import socket from '../../../../context/socket';
import YearSelect from '../../StartedYear/year';
import { fetchClientData } from '../../../../redux/client/clientSlice';
import { useDispatch } from 'react-redux';
import api from '../../../../utils/api';
import moment from 'moment';

// Reusable InputField Component
const InputField = ({ childId, field, value, onChange, onBlur, placeholder }) => (
  <input
    type="number"
    style={{
      border: 'none',
      borderBottom: '1px solid green',
      width: `${(value?.length || 1) + 3}ch`,
      paddingLeft: '1rem',
      minWidth: '7ch',
    }}
    className="clrgreen fw-bold ps-3 moinput"
    value={value || ''}
    onChange={(e) => onChange(childId, field, e.target.value)}
    onBlur={() => onBlur && onBlur(childId, field)}
    placeholder={placeholder}
  />
);

// Reusable SelectField Component
const SelectField = ({ childId, field, value, onBlur, onChange, options }) => (
  <select
    style={{
      border: 'none',
      borderBottom: '1px solid green',
      width: `${(value?.length || 1) + 3}ch`,
      paddingLeft: '1rem',
      minWidth: '8ch',
    }}
    className="clrgreen fw-bold ps-3 moinput"
    value={value || ''}
    onChange={(e) => onChange(childId, field, e.target.value)}
    onBlur={() => onBlur && onBlur(childId, field)}
  >
    <option value="">Select</option>
    {options.map((option) => (
      <option key={option} value={option}>{option}</option>
    ))}
  </select>
);

const EmergencyFundData = ({ roomId, card_id, planYourGoals, children }) => {
  const dispatch = useDispatch();
  const yearOptions = ["2025", "2026"];
  const planYourGoalsFiltered = planYourGoals.filter(item => item._id === "66d0280c9a75443e96fd3411");
  console.log("planYourGoalsFiltered", planYourGoalsFiltered);


  const [selectedCard, setSelectedCard] = useState(null);
  const [childrensData, setChildrensData] = useState(
    children.reduce((acc, child) => ({
      ...acc,
      [child._id]: { amount: "", inflation: "", goalYear: "", startYear: new Date().getFullYear().toString() },
    }), {})
  );
  const handleBlurSave = async (childId, field) => {


    try {
      const child = childrensData[childId] || {};
      const {
        amount = "",
        inflation = "",
        goalYear = "",
        startYear = new Date().getFullYear().toString(),
      } = child;

      // treat empty amount as "0" to match your earlier logic
      const amountVal = amount === "" ? "0" : amount;

      let goalText = ""
      if (childId) {

        const child = children.find(
          (c) => String(c._id) === String(childId)
        );
        if (child) {
          const ms = 'Marriage'
          goalText = child.name + "'s " + ms
        }
      }



      const isComplete = amountVal !== "0" && inflation && goalYear && startYear;

      const prevActionData = planYourGoals
        ?.find((item) => item._id === card_id)
        ?.action_data
        ?.find((ad) => String(ad.childId) === String(childId));

      const prevCreatedAt = prevActionData?.created_at;

      const actionDataItem = {
        maritalStatus: 'Marriage',
        goalText,
        childId,
        amount: amountVal,
        inflation,
        goalYear,
        startYear,
        status: isComplete ? 1 : 0,
      };

      const payload = {
        _id: roomId,
        dream_id: card_id,
        action_data: [actionDataItem],
        status: 1,
        priority: planYourGoalsFiltered?.[0]?.priority,
      };

      if (isComplete && !prevCreatedAt) {
        payload.created_at = new Date().toISOString();
      }

      console.log("Saving onBlur:", childId, field, payload);

      const res = await api.post(`advisor/save_goal_tracker_data`, payload);

      // keep existing behaviour: refresh client data after save
      dispatch(fetchClientData(roomId));

      console.log("Saved (onBlur):", res?.data);
    } catch (err) {
      console.error("Error saving (onBlur):", err);
    }
  };
  // Handle input changes with real-time saving
  const handleInputChange = async (childId, field, value) => {
    // Convert value to number only for numeric fields
    const numericFields = ["amount", "inflation", "goalYear"];
    const isNumeric = numericFields.includes(field);
    const numericValue = Number(value);

    // Prevent negative values for numeric fields
    if (isNumeric && numericValue < 0) {
      console.warn(`Negative value not allowed for ${field}`);
      return;
    }


    const updatedData = {
      ...childrensData,
      [childId]: {
        ...childrensData[childId],
        [field]: value,
      },
    };

    setChildrensData(updatedData);
    console.log("Input updated:", childId, field, value, updatedData, planYourGoals);
  };

  // Load saved card data into form
  useEffect(() => {
    if (!planYourGoals || !card_id) return;

    // Collect all card entries with matching card_id
    const cards = planYourGoals.filter((item) => item._id === card_id);
    if (!cards.length) return;

    setSelectedCard(cards[0]); // Just set one for socket or other logic

    const formattedData = {};

    // Loop through all matching cards and combine action_data by childId
    cards.forEach((card) => {
      card?.action_data?.forEach((item) => {
        formattedData[item.childId] = {
          amount: item.amount || "",
          inflation: item.inflation || "",
          goalYear: item.goalYear || "",
          startYear: item.startYear || new Date().getFullYear().toString(),
        };
      });
    });

    // Filter only children present in current children list
    const finalData = {};
    children.forEach((child) => {
      finalData[child._id] = formattedData[child._id] || {
        amount: "",
        inflation: "",
        goalYear: "",
        startYear: new Date().getFullYear().toString(),
      };
    });

    setChildrensData(finalData);
  }, [planYourGoals, card_id, children]);


  // Socket: Join room on mount
  useEffect(() => {
    if (roomId) {
      socket.emit("join", roomId);
    }
  }, [roomId]);

  // Debounced socket message emitter
  const debouncedEmitMessage = useCallback(
    _.debounce(() => {
      socket.emit("message", {
        room: roomId,
        data: {
          selectedCard,
          childrensData,
        },
      });
    }, 300),
    [selectedCard, childrensData, roomId]
  );

  useEffect(() => {
    debouncedEmitMessage();
  }, [childrensData, debouncedEmitMessage]);

  return (
    <>
      {children.map((child) => (
        <div key={child._id} className="mb-5">
          <div className="row ps-3">
            <div className="col-md-9 col-10">
              <p className="fs-21 lh-sm">
                <span className="clrgreen fw-semibold">{child.name}'s</span> Marriage
                <span className="clrgreen fw-semibold">{" "}({moment(child.dob).format("YYYY-MM-DD")}) </span>
              </p>
            </div>
          </div>
          {/* Amount */}
          <div className="row">
            <div className="col-md-1 col-2 heartwidth">
              <img src="/assets/images/heart.png" alt="heart icon" />
            </div>
            <div className="col-md-9 col-10">
              <p className="fs-21 lh-sm">
                If <span className="clrgreen fw-semibold">{child.name}</span> were getting married today, I would ideally like to have at least{" "}
                <span className="clrgreen fw-semibold">
                  <InputField
                    childId={child._id}
                    field="amount"
                    value={childrensData[child._id]?.amount}
                    onChange={handleInputChange}
                    onBlur={handleBlurSave}
                    placeholder="0"
                  />
                </span>{" "}saved up for this important family milestone.
              </p>
            </div>
          </div>

          {/* Inflation */}
          <div className="row">
            <div className="col-md-1 col-2 heartwidth">
              <img src="/assets/images/heart.png" alt="heart icon" />
            </div>
            <div className="col-md-8 col-10">
              <p className="fs-21 lh-sm">
                I expect these expenses to inflate at{" "}
                <span className="clrgreen fw-semibold">
                  <InputField
                    childId={child._id}
                    field="inflation"
                    value={childrensData[child._id]?.inflation}
                    onChange={handleInputChange}
                    onBlur={handleBlurSave}
                    placeholder="0"
                  />
                </span>{" "} % per year.
              </p>
            </div>
          </div>

          {/* Goal Year */}
          <div className="row">
            <div className="col-md-1 col-2 heartwidth">
              <img src="/assets/images/heart.png" alt="heart icon" />
            </div>
            <div className="col-md-8 col-10 mb-3">
              <p className="fs-21 lh-sm">
                My goal target is{" "}
                <span className="clrgreen fw-semibold">
                  <InputField
                    childId={child._id}
                    field="goalYear"
                    value={childrensData[child._id]?.goalYear}
                    onChange={handleInputChange}
                    onBlur={handleBlurSave}
                    placeholder="Year"
                  />
                </span>
              </p>
            </div>
          </div>

          {/* Start Year */}
          {/* <div className="row">
            <div className="col-md-1 col-2 heartwidth">
              <img src="/assets/images/heart.png" alt="heart icon" />
            </div>
            <div className="col-md-8 col-10">
              <p className="fs-21 lh-sm">
                Start Year{" "}
                <span className="clrgreen fw-semibold">
                  <SelectField
                    childId={child._id}
                    field="startYear"
                    value={childrensData[child._id]?.startYear}
                    onChange={handleInputChange}
                    options={yearOptions}
                  />
                </span>
              </p>
            </div>
          </div> */}

          <div className="row">
            <div className="col-md-1 col-2 heartwidth">
              <img src="/assets/images/heart.png" alt="heart icon" />
            </div>
            <div className="col-md-8 col-10 d-flex align-items-center">
              <p className="fs-21 lh-sm me-2 pt-3">Start Year</p>
              <div style={{ minWidth: "120px" }}>
                <YearSelect
                  childId={child._id}
                  field="startYear"
                  value={childrensData[child._id]?.startYear}
                  onChange={handleInputChange}
                  onBlur={handleBlurSave}
                  recentYear={new Date().getFullYear()}
                  customOptions={yearOptions} // optional
                />
              </div>
            </div>
          </div>
        </div>
      ))}
    </>
  );
};

export default EmergencyFundData;
